import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-si-glyph-note-2",
  "use": "icon-si-glyph-note-2-usage",
  "viewBox": "0 0 17 16",
  "content": "<symbol viewBox=\"0 0 17 16\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" class=\"si-glyph si-glyph-note-2\" id=\"icon-si-glyph-note-2\">\n    <!-- Generator: Sketch 3.0.3 (7891) - http://www.bohemiancoding.com/sketch -->\n    <title>1098</title>\n    \n    <defs></defs>\n    <g stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <path d=\"M15.016,0 L15.016,1.031 L13.954,1.031 L13.954,0 L13.059,0 L13.059,1.031 L11.969,1.031 L11.969,0 L11.016,0 L11.016,1.031 L9.954,1.031 L9.954,0 L9.032,0 L9.032,1.031 L7.941,1.031 L7.941,0 L7.016,0 L7.016,1.031 L5.985,1.031 L5.985,0 L5.043,0 L5.043,1.031 L3.959,1.031 L3.959,0 L3,0 L3,16 L15.954,16 L15.954,0 L15.016,0 L15.016,0 Z M5,6.958 L14,6.958 L14,7.958 L5,7.958 L5,6.958 L5,6.958 Z M14,11.958 L5,11.958 L5,10.958 L14,10.958 L14,11.958 L14,11.958 Z M14,10 L5,10 L5,9 L14,9 L14,10 L14,10 Z\" fill=\"#434343\" class=\"si-glyph-fill\" />\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/glyph/si-glyph-note-2.svg
// module id = PDeT
// module chunks = 62